import angular from 'angular';
import GridUtils from '~/components/kform/utils/kform-grid-utils';
import CustomController from './custom.controller';
import template from './custom.html';
import CustomComponent from './custom.component';

const customConfig = /* @ngInject */ (/** @type {any} */ KformComponentsProvider) => {
	KformComponentsProvider.register('custom', {
		title:      'Custom',
		template,
		group:      'advanced',
		children:   false,
		selectable: true,
		settings:   new CustomComponent(),
		tableView:  GridUtils.generic,
		icon:       'fa fa-cubes',
		views:      [
			{
				name:     'Display',
				template: 'kform/components/custom/display.html',
			},
			{
				name:     'Conditional',
				template: 'kform/components/common/conditional.html',
			},
		],
	});
};

// eslint-disable-next-line angular/controller-name
export default angular.module('app')
	.config(customConfig)
	.controller('customComponent', CustomController);
